// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchInput-module__wrapper___348AH","icon":"SearchInput-module__icon___BPVxu","input":"SearchInput-module__input___2BueX"};